import React from 'react';
import styled from 'styled-components';

import Contain from './contain';
import Title from './title';
import Video from './video';

const Section = styled.section`
  padding: 5rem 0;
  background: #fff;
  position: relative;
`;

const WorksContain = styled.div`
  padding: 5rem 0 0;
  text-align: center;
  position: relative;
  z-index: 1;
`;

const WorksDescription = styled.p`
  max-width: 40rem;
  margin: 0 auto;
  font-size: 1.1rem;
  font-weight: 500;
  line-height: 1.6;
`;

const VideoContain = styled.div`
  position: relative;
  margin: 4rem 0 2rem;
  display: inline-block;

  &:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 2rem;
    left: 2rem;
    border: 1px dashed #A0AEC0;
    border-radius: 4px;

    @media (max-width: 50rem) {
      top: .5rem;
      left: .5rem;
    }
  }

  > div,
  > video {
    position: relative;
    z-index: 1;
  }
`;

export default props => {
  return (
    <Section>
      <Contain>
        <WorksContain>
          <Title>How Quickpage works.</Title>
          <WorksDescription>
            Within a couple of minutes you can be the most unique agent in your neighborhood. Instantly stand out, build trust and gain new clients. <br />
            Click play and see how.
          </WorksDescription>

          <VideoContain>
            <Video
              url="https://qwickpage-dev.s3.amazonaws.com/media/C30DC416-DE45-4040-8833-E7BD5E53CBD0/hWYWL3dndx66WMcqa.mp4-web.mp4"
              poster="https://quickpage-assets.s3.amazonaws.com/public/marketing/poster.png"
              autoplay={true}
              noFrame={true}
            />
          </VideoContain>
        </WorksContain>
      </Contain>
    </Section>
  )
}
